module.exports = __webpack_public_path__ + "img/course-bigcover06.e09c6432.png";